import { createFileRoute } from '@tanstack/react-router';
import EntityAdmin from 'containers/EntityAdmin';

export const Route = createFileRoute('/_authenticated/entityAdmin')({
  component: EntityAdmin,
});
